import { render } from "./TaskTags.vue?vue&type=template&id=0a2306b7&scoped=true"
import script from "./TaskTags.vue?vue&type=script&lang=js"
export * from "./TaskTags.vue?vue&type=script&lang=js"

import "./TaskTags.vue?vue&type=style&index=0&id=0a2306b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2306b7"]])

export default __exports__